import React from 'react';
import { useRecoilValue } from 'recoil';
import { displayModelState } from 'features/file-browser/state/fileAtoms';
import { isVisibleModelState } from 'features/three-view/state/threeAtoms';
import { StlViewer } from '../utils/stlViewer';

export const ModelViewer: React.FC = () => {
  const displayModel = useRecoilValue(displayModelState);
  const isVisibleModel = useRecoilValue(isVisibleModelState);

  if (!displayModel || !isVisibleModel) return <></>;

  const url = displayModel.url;
  const name = displayModel.name.split('.').slice(0, -1).join('.');

  return <StlViewer
    url={url}
    name={name}
    defaultColor={'#3f7b9d'}
    label={'Model'}
  />;
};
